import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { getTriggerElementsFromElement } from '../../../libs/gin-tonic/helpers/dom/get-trigger-elements-form-element/index';

@Component({ className: 'js-dialog' })
export class DialogComponent {
	private triggers: HTMLElement[];
	private baseTitle = document.title;

	constructor(private element: HTMLDialogElement) {
		this.triggers = getTriggerElementsFromElement(this.element);

		this.triggers.forEach(trigger =>
			trigger.addEventListener('click', e => {
				e.preventDefault();
				this.toggle();
			})
		);

		this.element.addEventListener('click', e => {
			if (!e.target.closest('.c-dialog__content')) {
				this.close();
			}
		});

		if (window.location.hash && this.triggers.find(o => o.getAttribute('href')?.indexOf(window.location.hash.substring(1)) != -1)) {
			this.open();
		}
	}

	toggle() {
		if (this.element.open) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.element.showModal();
		this.addClass('is-open');
		this.removeClass('is-closed');
		const href = this.element.getAttribute('data-href');
		if (href) {
			document.title = this.element.title;
			window.history.pushState('', this.element.title, href);
		}
	}

	close() {
		this.element.close();
		this.removeClass('is-open');
		this.addClass('is-closed');
		const href = this.element.getAttribute('data-base-href');
		if (href) {
			document.title = this.baseTitle;
			window.history.pushState('', this.baseTitle, href);
		}
	}

	addClass(...tokens: string[]) {
		this.element.classList.add(...tokens);
		this.triggers.forEach(trigger => trigger.classList.add(...tokens));
	}

	removeClass(...tokens: string[]) {
		this.element.classList.remove(...tokens);
		this.triggers.forEach(trigger => trigger.classList.remove(...tokens));
	}
}
